export default __webpack_public_path__ + "static/media/screen_google_drive_00.61574c85.png";